import React from "react"
import Seo from "../../components/seo"
import { DocumentVerificationMeta } from "../../data/metaData"
import { Link } from "gatsby"
import Layout from "../../components/layout/layout"
import { Container, Row, Col, Card, Image } from "react-bootstrap"
import { StaticImage } from "gatsby-plugin-image"
import LazyLoad from "react-lazy-load"
import { Animations } from "../../components/animations"

import BannerAnimation from "../../animations/document-verification/document.json";

import Icon1 from "../../images/icon/search-file.svg"
import Icon2 from "../../images/icon/approve-file.svg"
import Icon3 from "../../images/icon/document-error.svg"
import Icon4 from "../../images/icon/folder.svg"


import IndustryIcon1 from "../../images/icon/money.svg"
import IndustryIcon2 from "../../images/icon/speaker.svg"
import IndustryIcon3 from "../../images/icon/account1.svg"
import IndustryIcon4 from "../../images/icon/invoice.svg"
import IndustryIcon5 from "../../images/icon/invoice-1.svg"
import IndustryIcon6 from "../../images/icon/high-brightness.svg"

const BlogList = React.lazy(() => import('../../components/blog-list'))

const schemaOrgJSONLD1 =
{
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "WebPage",
      "@id": "https://www.digipay.guru/ekyc/document-verification/",
      "url": "https://www.digipay.guru/ekyc/document-verification/",
      "name": "Document verification for advanced security in eKYC solution",
      "isPartOf": {
        "@id": "https://www.digipay.guru/#website"
      },
      "description": "Verify customers and prevent fraud with real-time document verification. DigiPay.Guru’s AI-powered document checks identify document fraud in less than a second",
      "breadcrumb": {
        "@id": "https://www.digipay.guru/ekyc/document-verification/#breadcrumb"
      },
      "inLanguage": "en-US",
      "potentialAction": [
        {
          "@type": "ReadAction",
          "target": [
            "https://www.digipay.guru/ekyc/document-verification/"
          ]
        }
      ]
    },
    {
      "@type": "BreadcrumbList",
      "@id": "https://www.digipay.guru/ekyc/document-verification/#breadcrumb",
      "itemListElement": [
        {
          "@type": "ListItem",
          "position": 1,
          "name": "advanced security in eKYC solution",
          "item": "https://www.digipay.guru/"
        },
        {
          "@type": "ListItem",
          "position": 2,
          "name": "Automated document verification"
        }
      ]
    },
    {
      "@type": "WebSite",
      "@id": "https://www.digipay.guru/#website",
      "url": "https://www.digipay.guru/",
      "name": "Digipay.Guru",
      "description": "Digipay.Guru",
      "potentialAction": [
        {
          "@type": "SearchAction",
          "target": {
            "@type": "EntryPoint",
            "urlTemplate": "https://www.digipay.guru/?s={search_term_string}"
          },
          "query-input": "required name=search_term_string"
        }
      ],
      "inLanguage": "en-US"
    }
  ]
}

export const Head = () => (
  <>
    <Seo
      title={DocumentVerificationMeta.metaTitle}
      description={DocumentVerificationMeta.metaDescription}
      ogImage={DocumentVerificationMeta.ogImage}
      twitterImage={DocumentVerificationMeta.twitterImage}
    />
    <script type="application/ld+json">
      {JSON.stringify(schemaOrgJSONLD1)}
    </script>
  </>
)

// markup
const DocumentVerification = () => {

  const FeaturesImg1 = '../../images/document-verification-financial-services.png';
  const FeaturesImg2 = '../../images/document-verification-human-resources.png';
  const FeaturesImg3 = '../../images/document-verification-travel-and-hospitality.png';
  const FeaturesImg4 = '../../images/document-verification-government-services.png';

  const ProcessImg1 = '../../images/face-verification-process-img5.png';
  const ProcessImg2 = '../../images/face-verification-process-img2.png';
  const ProcessImg3 = '../../images/face-verification-process-img3.png';
  const ProcessImg4 = '../../images/face-verification-process-img4.png';

  const CtaImg = '../../images/face-verification-cta-img.png'

  const SectionDarkBackgroundPattren = "../../images/sectino-dark-background-pattren.webp"

  const AgeVerification = "../../images/document-verification-age-verification.png"
  const NationalityVerification = "../../images/document-verification-nationality-verification.png"

  const SecureScalable = [
    {
      title: "Document validity check",
      description: "Determines the type of user identity document such as a driver’s license or passport",
      icon: Icon1,
    },
    {
      title: "Document format support",
      description: "Can classify and support any kind of document format such as PDF, doc, and more",
      icon: Icon2,
    },
    {
      title: "Document expiry",
      description: "Checks and determines whether the uploaded document has expired with date verification ",
      icon: Icon3,
    },
    {
      title: "OCR powered engine",
      description: "The intelligent OCR-powered engine can extract all the necessary data from the document",
      icon: Icon4,
    }
  ]

  const BannerList1 = [
    {
      text: "Real-time results"
    },
    {
      text: "Intelligent OCR scanning"
    },
    {
      text: "Unmatched fraud prevention"
    },
    {
      text: "Accurate document validation"
    }
  ]

  const ProcessPoints = [
    {
      number: "1. Upload",
      text: "The user uploads a picture of the government identity document",
      keyName: "process1",
    },
    {
      number: "2. Extraction",
      text: "DigiPay.Guru’s intelligent OCR technology scans and extracts document data automatically",
      keyName: "process2",
    },
    {
      number: "3. Verification",
      text: "DigiPay.Guru’s advanced AI-driven tech verifies the document format and data",
      keyName: "process3",
    },
    {
      number: "4. Outcome",
      text: "The verification outcome appears on their screen with a definitive “approve or reject”",
      keyName: "process4",
    }
  ]

  const FeaturesSection = [
    {
      title: "Financial services",
      desc: "Verifying identity documents for account opening, loan applications, and financial transactions to prevent fraud and comply with KYC  and AML regulations",
      keyName: "Features1",
    },
    {
      title: "Employment and human resources",
      desc: "Screening applicants' identity documents in the hiring process, background checks, and employee onboarding to verify eligibility and comply with employment laws.",
      keyName: "Features2",
    },
    {
      title: "Travel and hospitality",
      desc: "Confirming identity documents for hotel check-ins, flight bookings, car rentals, and more to enhance security and compliance with travel regulations.",
      keyName: "Features3",
    },
    {
      title: "Government services",
      desc: "Identity doc verification for passport applications, driver's license renewals, and government benefit programs to ensure eligibility and prevent identity theft.",
      keyName: "Features4",
    }
  ]

  const FinancialNeeds = [
    {
      BigTitle: "Age verification",
      description: "Set dynamic security standards tailored to age-restricted products and services. Catch fraud users with the wrong date of birth instantly via digital age checks.",
      keyname: "AgeVerification",
      listItem: [
        {
          listTitle: "Sensitive data protection",
        },
        {
          listTitle: "Instant fraud age detection",
        },
        {
          listTitle: "Comply with age requirements",
        },
      ]
    },
    {
      BigTitle: "Nationality verification",
      description: "Validate nationality instantly, ensure only those adhering to global compliance enter your system and mitigate identity fraud risks with our robust nationality verification check.",
      keyname: "NationalityVerification",
      listItem: [
        {
          listTitle: "Instant authenticity checks",
        },
        {
          listTitle: "Comprehensive document analysis",
        },
        {
          listTitle: "Global compliance with KYC/AML regulations",
        },
      ]
    },
  ]

  const ourPlatformBox = [
    {
      title: "Government ID",
      animation: IndustryIcon1,
    },
    {
      title: "Passport",
      animation: IndustryIcon2,
    },
    {
      title: "Driver’s license",
      animation: IndustryIcon3,
    },
    {
      title: "Tax bill",
      animation: IndustryIcon4,
    },
    {
      title: "Bank statement",
      animation: IndustryIcon5,
    },
    {
      title: "& More",
      animation: IndustryIcon6,
    }
  ]



  return (
    <>
      <Layout headerClass="navbar-dark">
        <section className="section section-background-dark d-md-flex align-items-center">
          {/* // EEF5FA */}
          <Container className="py-5 pb-lg-0 mt-lg-5">
            <Row className="align-items-center g-5">
              <Col lg={6} className="py-lg-5">
                <div className="banner-content">
                  <h1 className="font-size-18 fw-normal text-white opacity-75">
                    DOCUMENT VERIFICATION
                  </h1>
                  <h2 className="h1 title fw-semibold mb-4-lg font-size-64 text-white" style={{ marginRight: -40 }}>
                    Automated <span className="gradient-text1">document verification</span>
                  </h2>
                  <p className="text lead mb-4 pb-1 text-white opacity-75 max-width-650">
                    Streamline your identity verification process with robust document verification. Authenticate and validate the documents in seconds and with high-end security.
                  </p>
                  <ul className="mb-0 ps-4 text-white opacity-75">
                    {BannerList1?.map((item, index) => (
                      <li key={index}>{item.text}</li>
                    ))}
                  </ul>
                  <Link
                    to="/contact-us"
                    className="btn btn-lg btn-primary-theme btn-240 mt-4 mt-lg-5"
                  >
                    <span>Request a demo</span>
                  </Link>
                </div>
              </Col>
              <Col lg={6} className="text-center d-none d-lg-block">
                <div className="mx-auto" style={{ maxWidth: 500 }}>
                  <Animations animation={BannerAnimation} />
                </div>
              </Col>
            </Row>
          </Container>
          <StaticImage
            style={{ position: 'absolute' }}
            className='section-background-image'
            loading='lazy'
            src={SectionDarkBackgroundPattren}
            alt='Banner Background Pattren'
          />
        </section>

        <section className="section bg-white">
          <Container className="pt-5">
            <div className="w-75 mx-auto text-center">
              <div className="section-title mb-5 mb-lg-0 pb-1">
                <h2 className="heading fw-semibold mb-4">
                  4 steps to robust document <span className="text-primary">verification </span>
                </h2>
                <p className="lead">Unlock accurate document verification with this quick and easy validation process.</p>
              </div>
            </div>
            <Row className="g-5 py-lg-5" xs={1} md={2} sm={2} lg={4}>
              {ProcessPoints?.map((item, index) => (
                <Col key={index} className="text-center">
                  {
                    item.keyName === "process1" ?
                      <LazyLoad offsetVertical={1000}>
                        <StaticImage loading='lazy' className="mb-2" src={ProcessImg2} width={218} height={430} alt='ProcessImg' />
                      </LazyLoad> :
                      null
                  }
                  {
                    item.keyName === "process2" ?
                      <LazyLoad offsetVertical={1000}>
                        <StaticImage loading='lazy' className="mb-2" src={ProcessImg1} width={218} height={430} alt='ProcessImg' />
                      </LazyLoad> :
                      null
                  }
                  {
                    item.keyName === "process3" ?
                      <LazyLoad offsetVertical={1000}>
                        <StaticImage loading='lazy' className="mb-2" src={ProcessImg3} width={218} height={430} alt='ProcessImg' />
                      </LazyLoad> :
                      null
                  }
                  {
                    item.keyName === "process4" ?
                      <LazyLoad offsetVertical={1000}>
                        <StaticImage loading='lazy' className="mb-2" src={ProcessImg4} width={218} height={430} alt='ProcessImg' />
                      </LazyLoad> :
                      null
                  }
                  <h3>{item.number}</h3>
                  <p>{item.text}</p>
                </Col>
              ))}
            </Row>
          </Container>
        </section>
        <section className="section bg-light-new">
          <Container className="py-5">
            <Row className="g-5 align-items-center" xs={1}>
              <Col lg={5}>
                <div className="section-title sticky-section0">
                  <h2 className="heading fw-semibold mb-4">
                    The features that add more <span className="text-primary">security</span> to it
                  </h2>
                  <p className="lead">
                    Leverage our advanced feature suite designed to accurately authenticate and validate the documents for a secure & efficient onboarding process.
                  </p>
                  <div className="mt-4">
                    <Link to='/contact-us' className='btn btn-lg btn-primary-theme mt-4'>
                      <span>Get started</span>
                    </Link>
                  </div>
                </div>
              </Col>
              <Col lg={7}>
                <Row xs={1} md={2} className="g-4">
                  {SecureScalable?.map((item, index) => (
                    <Col key={index}>
                      <div className="bg-white shadow-box shadow-none equal-height rounded-4">
                        <div className="left-icon-box">
                          <div className="icon icon-size-70 rounded-3 mb-4 bg-light-new d-flex align-items-center justify-content-center">
                            <Image loading="lazy" className="lazyload" src={item.icon} width={46} height={46} alt="Features" />
                          </div>
                          <div>
                            <h3 className="heading mb-3 h4">{item.title}</h3>
                            <p className="mb-0 font-size-16">
                              {item.description}
                            </p>
                          </div>
                        </div>
                      </div>
                    </Col>
                  ))}
                </Row>
              </Col>
            </Row>
          </Container>
        </section>
        <section className="section bg-white">
          <Container className="pt-5">
            <div className="section-title mb-5 mb-lg-0 pb-1 max-width-950 mx-auto text-center">
              <h2 className="heading fw-semibold mb-4">
                Features that add extra authenticity to the <span className="text-primary">document verification solution</span>
              </h2>
              {/* <p className="max-width-950">Find the perfect fintech solution for your unique financial needs, all in one place. Transform your business by leveraging cutting-edge technology and robust security features.</p> */}
            </div>
            {FinancialNeeds?.map((item, index) => (
              <Row key={index} className="g-5 align-items-center py-lg-5" xs={1} lg={2}>
                <Col className={`text-center d-none d-lg-block ${index % 2 === 0 ? 'order-lg-2' : ''}`}>
                  {
                    item.keyname === "AgeVerification" ?
                      <StaticImage loading="lazy" src={AgeVerification} width={613} height={474} alt="AgeVerification" /> :
                      null
                  }
                  {
                    item.keyname === "NationalityVerification" ?
                      <StaticImage loading="lazy" src={NationalityVerification} width={613} height={474} alt="NationalityVerification" /> :
                      null
                  }
                </Col>
                <Col>
                  <div className="section-title responsive-card-box">
                    <p className="gradient-text1 mb-2">{item.smallTiele}</p>
                    <h3 className="font-size-40 heading-bottom-line fw-semibold mb-4">{item.BigTitle}</h3>
                    <p>{item.description}</p>
                    <ul className="bullet-list list-unstyled my-4 fw-medium">
                      {item.listItem?.map((item, index) => (
                        <li key={index} className="mb-3">{item.listTitle}</li>
                      ))}
                    </ul>
                  </div>
                </Col>
              </Row>
            ))}
          </Container>
        </section>
        <section className="section section-background-dark">
          <Container className="py-5">
            <div className="section-title mb-5 pb-1 text-center max-width-950 mx-auto">
              <h2 className="heading fw-semibold mb-4 text-white">Varied documents we <span className="text-primary">support for verification</span></h2>
              <p className="max-width-950 mx-auto text-white opacity-75">
                With DigiPay.Guru, you can verify all types of documents and more at your fingertips. And make your customers’ onboarding process frictionless.
              </p>
            </div>
            <Row className="g-4" xs={2} md={3} xl={6}>
              {ourPlatformBox?.map((item, index) => (
                <Col key={index}>
                  <div className={`dark-box text-center equal-height`}>
                    <div className="icon d-flex align-items-center justify-content-center icon-size-70 mb-4 dark-box p-0 mx-auto">
                      <div className={`${item.size50}`}>
                        <Image loading="lazy" className="lazyload" src={item.animation} width={40} height={40} alt="Features" />
                      </div>
                    </div>
                    <h3 className="heading h5 mb-0 text-white fw-normal">{item.title}</h3>
                  </div>
                </Col>
              ))}
            </Row>
            <div className="mt-4 text-center">
              <Link to='/contact-us' className='btn btn-lg btn-primary-theme mt-4'>
                <span>Learn more</span>
              </Link>
            </div>
          </Container>
          <StaticImage
            style={{ position: "absolute" }}
            className="section-background-image"
            loading="lazy"
            src={SectionDarkBackgroundPattren}
            alt="Section Background Pattren"
          />
        </section>

        <section className="section bg-light-new pb-lg-220">
          <Container className="py-5">
            <div className="w-75 mx-auto">
              <div className="section-title mb-5 pb-1 text-center">
                <h2 className="heading fw-semibold mb-4">
                  Leverage the power of the <span className="text-primary">document verification system</span>
                </h2>
                {/* <p className="lead">
                  Your business remains secure and your customers at peace. Our face verification comes with security features beyond your expectations!
                </p> */}
              </div>
            </div>
            <Row className="g-4" xs={1} lg={2}>
              {FeaturesSection?.map((item, index) => (
                <Col key={index}>
                  <Card className="bg-light3 equal-height p-0 border-0 rounded-4">
                    <Card.Body className="p-lg-5">
                      <h3 className="heading-bottom-line mb-4">{item.title}</h3>
                      <p className="mb-4 pb-2">{item.desc}</p>
                      {
                        item.keyName === "Features1" ?
                          <LazyLoad offsetVertical={1000}>
                            <StaticImage loading="lazy" src={FeaturesImg1} width={557} height={399} alt="FeaturesImg" />
                          </LazyLoad> :
                          null
                      }
                      {
                        item.keyName === "Features2" ?
                          <LazyLoad offsetVertical={1000} className="text-center">
                            <StaticImage loading="lazy" src={FeaturesImg2} width={557} height={399} alt="FeaturesImg" />
                          </LazyLoad> :
                          null
                      }
                      {
                        item.keyName === "Features3" ?
                          <LazyLoad offsetVertical={1000} className="text-center">
                            <StaticImage loading="lazy" src={FeaturesImg3} width={561} height={399} alt="FeaturesImg" />
                          </LazyLoad> :
                          null
                      }
                      {
                        item.keyName === "Features4" ?
                          <LazyLoad offsetVertical={1000} className="text-end">
                            <StaticImage loading="lazy" src={FeaturesImg4} width={557} height={399} alt="FeaturesImg" />
                          </LazyLoad> :
                          null
                      }
                    </Card.Body>

                  </Card>
                </Col>
              ))}
            </Row>
          </Container>
        </section>



        <section className='section section-background-dark py-lg-0'>
          <Container>
            <Row className='g-lg-5 align-items-center'>
              <Col lg={6} className='py-5'>
                <div className='section-title'>
                  <h2 className='heading fw-semibold mb-4 text-white'>
                    Ready to take your <span className='gradient-text1 fw-bold'>KYC process</span> one step further?
                  </h2>
                  <Link to='/contact-us' className='btn btn-lg btn-primary-theme mt-4'>
                    <span>Book a free demo</span>
                  </Link>
                </div>
              </Col>
              <Col lg={6} className='text-center align-self-start d-none d-lg-block' style={{ marginTop: "-150px" }}>
                <LazyLoad offsetVertical={1000}>
                  <StaticImage
                    loading='lazy'
                    src={CtaImg}
                    width={527}
                    height={729}
                    alt='CtaImg'
                  />
                </LazyLoad>
              </Col>
            </Row>
          </Container>
          <StaticImage
            style={{ position: 'absolute' }}
            className='section-background-image'
            loading='lazy'
            src={SectionDarkBackgroundPattren}
            alt='Section Page CTA'
          />
        </section>



        <BlogList
          category='eKYC'
          sectionClass="bg-white"
          title="Read our insightful blogs!"
          description="Stay updated with the latest trends and innovations in finTech with our insightful blogs."
        />
      </Layout >
    </>
  )
}

export default DocumentVerification
